module.exports = __webpack_public_path__ + "img/back-editor.dea6e576.png";